import { Checkbox, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { CertificateMultipleChoiceQuestion } from 'src/types/CertificateQuestion'

type MultipleChoiceAnswersProps = {
    question: CertificateMultipleChoiceQuestion
}

export function MultipleChoiceAnswers({ question }: MultipleChoiceAnswersProps) {
    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell width="auto">Antwort</TableCell>
                        <TableCell align="center" width={12}>
                            Deine Antwort
                        </TableCell>
                        <TableCell align="center" width={12}>
                            Richtig
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {question.answers.map((a) => (
                        <TableRow key={a._id}>
                            <TableCell>{a.text}</TableCell>
                            <TableCell>
                                <Checkbox disableRipple checked={a.answered} />
                            </TableCell>
                            <TableCell>
                                <Checkbox disableRipple checked={a.isCorrect} />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}
